import { Flex } from '@chakra-ui/react';
import { Card, CardTitle } from 'components/UI';

const ProductSection = ({ name, children }: { name: string; children?: React.ReactNode }) => {
  const isParameterSection = name === 'PARAMETERS';
  return (
    <Card pb={isParameterSection ? 0 : 2}>
      <CardTitle sx={{ m: 0, bg: 'white', pl: 0, fontWeight: 'bold' }}>{name}</CardTitle>
      <Flex
        sx={{
          flex: 1,
          flexDir: 'column',
          px: isParameterSection ? 0 : 2.5,
          pt: isParameterSection ? 0 : 2,
          justifyContent: 'stretch',
        }}
      >
        {children}
      </Flex>
    </Card>
  );
};

export default ProductSection;
